<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Chi tiết kích hoạt serial number</div>
      </div>
      <div class="card card-w-title">
        <div class="box-top-list">
          <span class="p-m-0 format-title">Chi tiết kích hoạt bảo hành</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
          </span>
        </div>
        <div class="box-info p-fluid p-grid">
          <div class="p-col-6">
            <div class="box-info-title">THÔNG TIN KHÁCH HÀNG</div>
            <div class="form-info">
              <div class="p-field">
                <label>Tên khách hàng</label>
                <span>{{ full_name }}</span>
              </div>
              <div class="p-field">
                <label>Số điện thoại</label>
                <span>{{ phone_number }}</span>
              </div>
              <div class="p-field">
                <label>Nhóm khách hàng</label>
                <span>{{ group_customer }}</span>
              </div>
            </div>
            <div class="box-top-list box-info-product">
              <span class="box-info-title">THÔNG TIN SẢN PHẨM</span>
              <div class="right-button" v-if="display_btn_warranty_extension">
                <!--v-if="waittingActive"-->
                 <Button
                  v-if="$myConstants.checkRoleGroup('warranty_activation', 'time_extension')"
                  type="button"
                  :icon="'pi pi-pencil'"
                  :class="'p-button-edit'"
                  style="margin-right: 0.5em;"
                  @click="editProducts"
                ></Button>
              </div>
            </div>
            <div class="form-info">
              <div class="p-field">
                <label>Trạng thái bảo hành</label>
                <span v-html="warranty_status"></span>
              </div>

              <div class="p-field">
                <label>Model sản phẩm</label>
                <span > {{ model_code }}</span>
              </div>
              <div class="p-field">
                <label>Tên sản phẩm</label>
               <span v-if="listData && listData.name != undefined && listData.name != null"> {{ listData.name }}</span>
              </div>
              <div class="p-field">
                <label>Serial number</label>
                <span v-if="listData && listData.product_serial_number != undefined && listData.product_serial_number != null"> {{ listData.product_serial_number.serial_number }}</span>
              </div>
              <div class="p-field">
                <label>Nhóm sản phẩm</label>
                <span v-if="listData && listData.categories != undefined && listData.categories != null "> {{ listData.categories.name }}</span>
              </div>
              <div class="p-field">
                <label>Thời hạn bảo hành</label>
                <span v-html="warranty_time"></span>
              </div>
              <div class="p-field">
                <label>Thời hạn đổi</label>
                <span v-html="change_time"></span>
              </div>

               <div class="p-field">
                <label>Thời hạn trả</label>
                <span v-html="returnable_time"></span>
              </div>
              <div class="p-field">
                <label>Ngày sản xuất</label>
                <span > {{ created_date }}</span>
              </div>
              <div class="p-field">
                <label>Ngày bán sản phẩm</label>
                <span > {{ date_of_sale }}</span>
              </div>
              <div class="p-field">
                <label>Ngày kích hoạt bảo hành</label>
                <span > {{ activation_date }}</span>
              </div>
              <div class="p-field">
                <label>Ngày hết hạn bảo hành</label>
                <span > {{ expired_activation_date }}</span>
              </div>
              <!-- <div class="p-field display-none1">
                <label>Lý do đổi thời hạn BH</label>
                <span>{{ reason_warranty }}</span>
              </div> -->
            </div>
          </div>
          <div class="p-col-5 p-offset-1">
            <div class="form-info" v-if="dynamicForms && dynamicForms.length">
              <div class="box-info-title">THÔNG TIN KÍCH HOẠT</div>
              <div  class="p-field" :key="index" v-for="(item, index) in dynamicForms">
                  <label>{{ item.name }}</label>
                  <span>{{ item.value }}</span>
              </div>
            </div>
            <div class="box-info-title" v-if="lstImages && lstImages.length">HÓA ĐƠN BÁN HÀNG</div>
            <!-- <div class="box-invoice-img" v-if="invoiceImages && invoiceImages.length > 0">
              <img width="100px" height="150px"  :key="index" v-for="(item, index) in invoiceImages" :src="(item.url != undefined ? item.url : (item.cdn != null ? item.cdn + '' + item.path : item.path))"/>
            </div> -->
            <div class="box-invoice" v-if="lstImages && lstImages.length">
              <CoolLightBox
                class="box-invoice-img"
                :items="lstImages" 
                :index="indexInvoice"
                :fullScreen="true"
                :thumbsPosition="'center'"
                @close="indexInvoice = null">
              </CoolLightBox>

              <div class="images-wrapper">
                <div
                  class="image"
                  v-for="(image, imageIndex) in lstImages"
                  :key="imageIndex"
                  @click="setIndex(imageIndex)"
                  :style="{ backgroundImage: 'url(' + image.src + ')' }"
                ></div>
              </div>
            </div>

            <div class="box-info-title" v-if="listData && verify_status == 1 && lstAcceptance && lstAcceptance.length">BIÊN BẢN NGHIỆM THU</div>
            <div class="box-invoice" v-if="listData && verify_status == 1 && lstAcceptance && lstAcceptance.length">
              <CoolLightBox
                class="box-invoice-img"
                :items="lstAcceptance" 
                :index="indexAcceptance"
                :fullScreen="true"
                :thumbsPosition="'center'"
                @close="indexAcceptance = null">
              </CoolLightBox>
              <div class="images-wrapper">
                <div
                  class="image"
                  v-for="(image1, imageIndex1) in lstAcceptance"
                  :key="imageIndex1"
                  @click="setIndexAcceptance(imageIndex1)"
                  :style="{ backgroundImage: 'url(' + image1.src + ')' }"
                ></div>
              </div>
            </div>
            <!-- <div class="box-invoice-img" v-if="listData && verify_status == 1 && acceptanceImages && acceptanceImages.length > 0">
              <img width="100px" height="150px" :key="index1" v-for="(item1, index1) in acceptanceImages" :src="(item1.url != undefined ? item1.url : (item1.cdn != null ? item1.cdn + '' + item1.path : item1.path))"/>
            </div> -->
          </div>
        </div>
        <div class="box-top-list display-none" v-if="visibleWarranty">
          <span class="p-m-0">Tắt kích hoạt bảo hành sản phẩm</span>
        </div>
        <div class="box-reason p-fluid p-grid display-none" v-if="visibleWarranty">
          <div class="p-col-6">
            <div class="form-info">
              <div class="p-field">
                <label>Lý do tắt kích hoạt <span class="error">*</span></label>
              </div>
            </div>
            <div class="form-info">
              <div class="p-field p-grid">
                <div class="p-col-7 ">
                  <Dropdown @input="changeReason" v-model="reasonItem" :options="reasonTypes" optionLabel="name" placeholder="Chọn lý do" />
                  <p class="txt-right"><small v-if="submitReject && Object.keys(reasonItem).length == 0"
                        class="p-invalid" >Chọn lý do</small></p>
                </div>
                <div class="p-col-4 p-offset-1">
                  <Button label="Tắt kích hoạt" class="p-button-danger"  @click="disableAction"/>
                </div>
                <div class="p-col-7" v-if="reasonItem != undefined && reasonItem != null && reasonItem.is_change_product">
                  <div class="p-field">
                    <label>Serial number mới <span class="error">*</span></label>
                  </div>
                  <div class="p-field">
                    <InputText maxlength="255" id="changed_serial_number_id" type="text" v-model="changed_serial_number_id"/>
                    <p class="txt-right"><small v-if="submitReject && errorReject > 0"
                            class="p-invalid" > {{ errorReasonNote }}</small></p>
                  </div>
                </div>
                <div class="p-col-7" v-if="reasonItem != undefined && reasonItem != null && reasonItem.is_add_info">
                  <div class="p-field">
                    <Textarea  :autoResize="true" rows="2" v-model="reason_note" placeholder="Nhập lý do tắt kích hoạt bảo hành *"/>
                    <p class="txt-right"><small v-if="submitReject  && reason_note.length == 0"
                            class="p-invalid" >Nhập lý do chi tiết</small></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-top-list last-changed">
          <span class="p-m-0 format-title">Lịch sử kích hoạt bảo hành</span>
        </div>
        <div class="box-info log-changed">
          <div class="list-data">
            <BaseCommon v-if="dataModelLog"
              :key="componentKeyLog"
              :listData="listDataLog"
              :model="dataModelLog"
              :isFilter="false"
              :pagination="false"
            ></BaseCommon>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      class="dialog-reject"
      :visible.sync="showConfirmDialog"
      :contentStyle="{overflow: 'visible'}"
      :modal="true"
      :showHeader="false"
    >
      Xác nhận tắt kích hoạt bảo hành sản phẩm?
      <template
        #footer
      >
        <Button label="Có" @click="confirmAction()" />
        <Button label="Không" class="p-button-danger" @click="showConfirmDialog = false"/>
      </template>
    </Dialog>
    <!--<Dialog
        :header="'Chỉnh sửa thông tin sản phẩm'"
        :visible.sync="displayDialogChangeProduct"
        :contentStyle="{overflow: 'visible'}"
        :style="{width: '40vw'}"
        :class="'popup-dialog'"
        :modal="true"
      >
      <div class="p-fluid">
        <div class="p-col-12 form-popup-custom">
            <div class="p-field">
                <label>Thời hạn bảo hành</label>
            </div>
            <div class="p-field edit-time-product">
              <div class="p-inputgroup">
                <InputNumber v-model="warranty_activation_time" :min="0"/>
                <span class="p-inputgroup-addon">
                    Tháng
                </span>
              </div>
              <small v-if="submitChangeProduct  && (warranty_activation_time.length == 0 || warranty_activation_time == 0)"
                            class="p-invalid" >Nhập thời hạn bảo hành</small>
            </div>
            <div class="p-field ">
                <label>Lý do đổi thời hạn bảo hành<span class="error">*</span></label>
            </div>
            <div class="p-field">
              <Textarea maxlength="500"  :autoResize="true" rows="2" v-model="warranty_activation_note" />
              <small v-if="submitChangeProduct  && warranty_activation_note.length == 0"
                            class="p-invalid" >Nhập lý do đổi thời hạn bảo hành</small>
            </div>
        </div>
      </div>
      <template #footer>
          <Button  class="p-button-success" :label="'Lưu'" @click="changeProductData" />
      </template>
    </Dialog>-->
    <Dialog
        :header="'Gia hạn thời gian bảo hành'"
        :visible.sync="displayDialogChangeProduct"
        :contentStyle="{overflow: 'visible'}"
        :style="{width: '40vw'}"
        :class="'popup-dialog box_extend'"
        :modal="true"
    >
      <div class="p-fluid">
        <div class="p-col-12 form-popup-custom">
          <div class="p-grid">
            <div class="p-col-6">
              <div class="p-field">
                <label>Số ngày gia hạn</label>
              </div>
              <div class="p-field group_input_day">
                <InputNumber @keyup="change_number_ext_days" class="warranty_activation_time" v-model="popupExtend.number_extension_days" :min="-1" :max="10000"/>
                <span class="refix-wat" >Ngày</span>
              </div>
              <div class="p-field">
                <!--<div v-if="validationErrors && validationErrors['unit_price']">
                  <small v-if="validationErrors['unit_price'] == 1"
                         class="p-invalid" >Vui lòng nhập số dương.</small>
                </div>-->
                <small v-if="validationErrors && validationErrors['number_extension_days']" class="p-invalid" >{{validationErrors['number_extension_days']}}</small>
                <p class="style_time_max">Tối đa: <span>{{popupExtend.maximum_warranty_extension_time}} ngày</span></p>
              </div>
            </div>
            <div class="p-col-6">
              <div class="p-field">
                <label>Ngày hết hạn BH dự kiến</label>
              </div>
              <div class="p-field">
                <div class="box_expiration_date" >
                  <span>{{ popupExtend.expected_warranty_expiration_date }}</span>
                  <img :src="img_calenda" />
                </div>
              </div>
            </div>
          </div>

          <div class="p-field ">
            <label>Nguyên nhân gia hạn thời gian bảo hành<span class="error">*</span></label>
          </div>
          <div class="p-field">
            <Textarea maxlength="500"  :autoResize="true" rows="2" v-model="popupExtend.warranty_activation_note" />
            <small v-if="validationErrors && validationErrors['warranty_activation_note']" class="p-invalid" >{{validationErrors['warranty_activation_note']}}</small>
          </div>
        </div>
      </div>
      <template #footer>
        <Button  class="p-button-success" :label="'Lưu'" @click="changeProductData" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import moment from "moment";
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      listData: [],
      dataModel: null,
      listDataLog: [],
      dataModelLog: null,
      componentKey: 0,
      componentKeyLog: 0,
      full_name: '',
      phone_number: '',
      group_customer: '',
      invoiceImages: [],
      invoiceImagesTmp: [],
      lstImages: [],
      indexInvoice: null,
      acceptanceImages: [],
      lstAcceptance: [],
      indexAcceptance: null,
      product_serial_id: 0,
      request_activation_id: 0,
      created_date: '',
      date_of_sale: '',
      activation_date: '',
      expired_activation_date: '',
      reason_warranty: '',
      reason_warranty_old: '',
      warranty_status: '',
      warranty_time: '',
      warranty_time_data: 0,
      warranty_unit: '',
      warranty_time_tmp_data:null,
      warranty_unit_tmp_data:null,
      returnable_time: '',
      change_time: '',
      verify_status: - 1,
      model_code: '',
      reasonTypes: [],
      reasonItem: {},
      serial_number: '',
      serial_number_id: 0,
      changed_serial_number_id: '',
      changed_serial_number_new_id: '',
      reason_note: '',
      submitReject: false,
      errorReasonNote: '',
      errorReject: 0,
      showConfirmDialog: false,
      organizationID: 0,
      visibleWarranty: false,
      displayDialogChangeProduct: false,
      submitChangeProduct: false,
      warranty_activation_time: 0,
      warranty_activation_note: '',
      dynamicForms: [],
      waittingActive: false,
      img_calenda:window.origin + '/assets/images/calenda_icon.png',
      popupExtend: {
        expected_warranty_expiration_date: '',
        number_extension_days: null,
        activation_date: null,
        warranty_time: 0,
        warranty_unit: null,
        maximum_warranty_extension_time: 0,
        expiration_date: null,
        warranty_activation_note: '',
        remaining_warranty_period_old:0,//Thời gian bảo hành còn lại của sản phẩm cũ
      },
      display_btn_warranty_extension:false,
      validationErrors: {},
    }
  },
  async mounted () {
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      this.product_serial_id = Number(this.$route.params.id);
      await this.getData();
      await this.settingReasonReject();
    }
  },
  methods: {
    async disableAction() {
      this.$store.commit('setDataLoading', {content: 'Đang kiểm dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.submitReject = true;
      this.errorReject = -1;
      this.errorReasonNote = '';
      if (this.reasonItem && Object.keys(this.reasonItem).length) {
        if (this.reasonItem.is_change_product) {
          if (this.changed_serial_number_id != '' && this.changed_serial_number_id.length > 0) {
            await this.checkSeiralNumber(this.changed_serial_number_id);
          }
          else {
            this.errorReasonNote = 'Nhập serial number';
            this.errorReject = 1;
          }
        } else if (this.reasonItem.is_add_info && this.reason_note.length == 0) {
          this.errorReject = 1;
        } else {
          if (this.changed_serial_number_id != '' && (this.changed_serial_number_new_id == '' || this.changed_serial_number_new_id == null)) {
            this.errorReject = 1;
            this.errorReasonNote = 'Vui lòng nhập mã serial cùng model với sản phẩm cũ';
          }
          else this.showConfirmDialog = true;
        }
      }
      this.$store.commit('setLoading', false);
    },
    async confirmAction() {
      if (this.serial_number_id > 0)  {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        this.showConfirmDialog = false;
        var variables = {
          where_key: {
            serial_number_id: {'_eq': this.serial_number_id },
            warranty_status: {'_neq': 3},
            status: {'_eq': 1}
          }
        }
        var data = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variables), "fields": "serial_number_id "});
        if (data != null) {
          await this.processReject();
        } else {
          this.showConfirmDialog = false;
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Sản phẩm không hợp lệ, vui lòng kiểm tra lại trước khi tiếp tục', life: 3000 })
        }
      }
    },
    async processReject() {
      var info = this.listData;
      var organizationUser = (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null &&
      this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null
      && this.$store.getters.fullname.organization_account.organization_id != undefined && 
      this.$store.getters.fullname.organization_account.organization_id != null) ? this.$store.getters.fullname.organization_account.organization_id: 0;

      this.organizationID = (info.request_activation != undefined && info.request_activation != null && info.request_activation.organization_id != undefined && info.request_activation.organization_id != null) ? info.request_activation.organization_id : 0;
      var customerID = (info.request_activation != undefined && info.request_activation != null && info.request_activation.organization_id != undefined && info.request_activation.organization_id != null) ? info.request_activation.customer_profile_id : 0;
      // console.log('dddddddd', customerID, this.organizationID, info);
      // cập nhật trạng thái tắt kích hoạt cho request_activation_product_serial
      var whereKey = { request_activation_id: {'_eq': this.request_activation_id }, serial_number_id: {'_eq': this.serial_number_id } }
      var paramsUpdate = { modified_date: this.$myConstants.currentDate(), warranty_status: 5 }
      await DataServices.updateData('request_activation_product_serial', {"variables": JSON.stringify({data_update: paramsUpdate, where_key: whereKey})});

      // cập nhật trạng thái tắt kích hoạt cho product_serial_number_info
      var whereInfo = { serial_number_id: {'_eq': this.serial_number_id } }
      var paramsInfo = { modified_date: this.$myConstants.currentDate(), warranty_status: 5, customer_profile_id: customerID,  organization_id: this.organizationID }
      // console.log('11111111111    ', JSON.stringify({data_update: paramsInfo, where_key: whereInfo}))
      await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: paramsInfo, where_key: whereInfo})});

      // tạo log product_serial_number_info 
      var variablesSerial = {
        where_key: {
          serial_number_id: {'_eq': this.serial_number_id },
          status: {'_eq': 1}
        }
      }
      var dataSerial = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variablesSerial), "fields": "serial_number_id product_id request_activation_id product_serial_number { serial_number warranty_status production_status production_order_code product_id status product { warranty_time warranty_unit change_time change_unit returnable_time returnable_unit change_time change_unit is_manually_verification}} customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit is_returnable change_time change_unit returnable_time  returnable_unit change_time change_unit last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form"});
      var listSerial = dataSerial[Object.keys(dataSerial)];
      if (listSerial != null && listSerial.length > 0) {
        var rowSerialNew = listSerial[0];
        rowSerialNew['warranty_status'] = 5;
        var message = this.reasonItem.name;
       
        if (this.changed_serial_number_id != '') {
          message += '.Serial number mới: ' + this.changed_serial_number_id;
        }

        if (this.reason_note != '') {
           message += '. ' + this.reason_note;
        }

        rowSerialNew['message'] = message;
        rowSerialNew['organization_id'] = organizationUser;

        var rowSerialChangeLog = {};
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'request_activation_id': this.request_activation_id })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'serial_number_id': this.serial_number_id })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'modifier_id': this.$store.getters.fullname.id })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'old_value': JSON.stringify(listSerial[0]) })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'new_value': JSON.stringify(rowSerialNew) })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'created_date': this.$myConstants.currentDate() })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'modified_date': this.$myConstants.currentDate() })
        await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: rowSerialChangeLog})});
        // console.log('22222222222222 log   ',  JSON.stringify({objects: rowSerialChangeLog}))
      }

      // thay đổi trang thái product_serial_number_info_status_changed
      var params = {}
      var listSerial2 = {};
     
      params = Object.assign(params, { 'request_activation_id': this.request_activation_id })
      params = Object.assign(params, { 'serial_number_id': this.serial_number_id })
      params = Object.assign(params, { 'old_warranty_status': info.warranty_status })
      params = Object.assign(params, { 'old_verify_status': info.verify_status})
      params = Object.assign(params, { 'new_warranty_status': 5})
      params = Object.assign(params, { 'modifier_id': this.$store.getters.fullname.id })
      params = Object.assign(params, { 'customer_profile_id':  customerID } )
      params = Object.assign(params, { 'organization_id': organizationUser })
      params = Object.assign(params, { 'reason_type': this.reasonItem.reason_type })
      params = Object.assign(params, { 'reason_code': this.reasonItem.code })
      params = Object.assign(params, { 'source': 'web' })
      if (this.reason_note.length > 0) params = Object.assign(params, { 'note': this.reason_note })
      if (this.changed_serial_number_id.length > 0) params = Object.assign(params, { 'changed_serial_number_id': this.changed_serial_number_new_id })
      params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() })
      await DataServices.insertData('product_serial_number_info_status_changed', {"variables": JSON.stringify({objects: params})});
      // console.log('3333333333 change   ',  JSON.stringify({objects: params}))
      // tạo log request_activation_changed_log 
      var variablesActivation = {
        where_key: {
          id : {'_eq': this.request_activation_id },
          status: {'_eq': 1}
        }
      }
      var dataActivation = await DataServices.getList('request_activation', {"variables": JSON.stringify(variablesActivation), "fields": "customer_profile_id author_id organization_id created_date modified_date status invoice_images acceptance_images description date_of_sale"});
      var listActivation = dataActivation[Object.keys(dataActivation)];
      if (listActivation != null && listActivation.length > 0) {
        var rowActivationNew = listActivation[0];
        var rowActivationChangeLog = {};
        message = 'Không nghiệm thu 1 sản phẩm';
        if (this.changed_serial_number_id.length > 0) {
          message += '. Đổi serial number mới: ' + this.changed_serial_number_id;
        }
        rowActivationChangeLog['message'] = message;

        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'request_activation_id':this.request_activation_id })
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'modifier_id': this.$store.getters.fullname.id })
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'organization_id': organizationUser })
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'message': message })
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'old_value': JSON.stringify(listActivation[0]) })
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'new_value': JSON.stringify(rowActivationNew) })
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'created_date': this.$myConstants.currentDate() })
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'modified_date': this.$myConstants.currentDate() })
        await DataServices.insertData('request_activation_changed_log', {"variables": JSON.stringify({objects: rowActivationChangeLog})});
      }

      if (this.changed_serial_number_id != '' && this.changed_serial_number_new_id != '') {

        var dataNewProductSerial = {};
        dataNewProductSerial['request_activation_id'] = this.request_activation_id;
        dataNewProductSerial['serial_number_id'] = this.changed_serial_number_new_id;
        dataNewProductSerial['created_date'] =  this.$myConstants.currentDate();
        dataNewProductSerial['modified_date'] =  this.$myConstants.currentDate();
        dataNewProductSerial['warranty_status'] = 2;
        dataNewProductSerial['verify_status'] = 0;
        dataNewProductSerial['user_id'] =  this.$store.getters.fullname.id;
        dataNewProductSerial['status'] = 1;
        dataNewProductSerial['activation_date'] =  this.$myConstants.currentDate();

        // thêm sản phẩm vào request_activation_product_serial
        var dataActivation1 = await DataServices.getList('request_activation_product_serial', {"variables": JSON.stringify({where_key: {serial_number_id: {'_eq': this.changed_serial_number_new_id }, request_activation_id: {'_eq': this.request_activation_id }}}), "fields": "request_activation_id serial_number_id user_id created_date modified_date last_modifier activation_date warranty_status verify_status status"});
        var listActivation1 = dataActivation1[Object.keys(dataActivation1)];
        if (dataActivation1 != null && Object.keys(listActivation1).length) {
          await DataServices.updateData('request_activation_product_serial', {"variables": JSON.stringify({data_update: dataNewProductSerial, where_key: {serial_number_id: {'_eq': this.changed_serial_number_new_id }, request_activation_id: {'_eq': this.request_activation_id }}})});
        } else {
          await DataServices.insertData('request_activation_product_serial', {"variables": JSON.stringify({objects: dataNewProductSerial})});
        }
        var variablesSerial1 = {
          where_key: {
            serial_number_id: {'_eq': this.changed_serial_number_new_id },
            status: {'_eq': 1}
          }
        }
        var dataSerial1 = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variablesSerial1), "fields": "serial_number_id product_id request_activation_id request_activation { id } customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit is_returnable change_time change_unit returnable_time  returnable_unit last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form "});
        var listSerial1 = dataSerial1[Object.keys(dataSerial1)];
        if (listSerial1 != null && listSerial1.length > 0) {
          // cập nhật lại product_serial_number_info
          var whereInfo1 = { serial_number_id: {'_eq': this.changed_serial_number_new_id } }
          var paramsInfo1 = {};
          var warrantyStatus = listSerial1[0].warranty_status == 5 ? 2 : listSerial1[0].warranty_status;
          var verifyStatus = listSerial1[0].warranty_status == 5 ? 0 : listSerial1[0].verify_status;
          paramsInfo1 = Object.assign(paramsInfo1,  {request_activation_id: this.request_activation_id});
          paramsInfo1 = Object.assign(paramsInfo1,  {modified_date: this.$myConstants.currentDate()});
          paramsInfo1 = Object.assign(paramsInfo1,  {verify_status: verifyStatus});
          paramsInfo1 = Object.assign(paramsInfo1,  {warranty_status: warrantyStatus});
          await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: paramsInfo1, where_key: whereInfo1})});
          
          // console.log('44444444444444444444444   ',  paramsInfo1,JSON.stringify({data_update: paramsInfo1, where_key: whereInfo1}))
        } else  {
          // thêm sản phẩm vào product_serial_number_info 
          var rowSerialNewChange = {
            serial_number_id: this.changed_serial_number_new_id,
            customer_profile_id: customerID,
            organization_id: this.organizationID,
            request_activation_id: this.request_activation_id,
            warranty_status: 2,
            verify_status: 0,
            status: 1,
            created_date: this.$myConstants.currentDate(),
            modified_date: this.$myConstants.currentDate()
          };

          var variablesProduct = {
            where_key: {
              product_serial_number: {
                id: {'_eq': this.changed_serial_number_new_id },
                status: {'_eq': 1}
              },
              status: {'_eq': 1}
            }
          }
          var dataProduct = await DataServices.getList('product', {"variables": JSON.stringify(variablesProduct), "fields": "id model_code name description thumbnail_id warranty_time warranty_unit is_returnable change_time change_unit returnable_time returnable_unit last_modifier is_manually_verification qr_code_size category_id"});
          var listProduct = dataProduct[Object.keys(dataProduct)];
          if (listProduct != null && listProduct.length > 0) {
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {product_id: listProduct[0].id});
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {model_code: listProduct[0].model_code});
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {name: listProduct[0].name});
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {description: listProduct[0].description});
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {thumbnail_id: listProduct[0].thumbnail_id});
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {warranty_time: listProduct[0].warranty_time});
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {warranty_unit: listProduct[0].warranty_unit });
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {is_returnable: listProduct[0].is_returnable });
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {returnable_time: listProduct[0].returnable_time });
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {returnable_unit: listProduct[0].returnable_unit });
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {change_time: listProduct[0].change_time });
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {change_unit: listProduct[0].change_unit });
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {last_modifier: listProduct[0].last_modifier });
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {is_manually_verification: listProduct[0].is_manually_verification });
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {qr_code_size: listProduct[0].qr_code_size });
            rowSerialNewChange = Object.assign(rowSerialNewChange,  {category_id: listProduct[0].category_id });

          }

          await DataServices.insertData('product_serial_number_info', {"variables": JSON.stringify({objects: rowSerialNewChange})});

          // console.log('5555555555555   ', JSON.stringify({objects: rowSerialNewChange}));

          listSerial2 = rowSerialNewChange;
         
        }

        var product_serial_number_text = (info.product_serial_number !== undefined && info.product_serial_number !== null) ? info.product_serial_number.serial_number : '';
        listSerial2['request_activation'] = {id: this.request_activation_id}
        listSerial2['message'] = 'Gửi yêu cầu kích hoạt bảo hành thay thế Serial number ' + product_serial_number_text;
        listSerial2['invoice_images'] = this.invoiceImagesTmp;
        listSerial2['organization_id'] = organizationUser;
        
        // listSerial1['warranty_status'] = 2;
        // listSerial1['verify_status'] = 0;

        // thêm product_serial_number_info_log_changed
        var rowSerialChangeLog1 = {};
        rowSerialChangeLog1 = Object.assign(rowSerialChangeLog1, { 'request_activation_id': this.request_activation_id })
        rowSerialChangeLog1 = Object.assign(rowSerialChangeLog1, { 'serial_number_id': this.changed_serial_number_new_id})
        rowSerialChangeLog1 = Object.assign(rowSerialChangeLog1, { 'modifier_id': this.$store.getters.fullname.id })
        rowSerialChangeLog1 = Object.assign(rowSerialChangeLog1, { 'new_value': JSON.stringify(listSerial2)})
        rowSerialChangeLog1 = Object.assign(rowSerialChangeLog1, { 'created_date': this.$myConstants.currentDate() })
        rowSerialChangeLog1 = Object.assign(rowSerialChangeLog1, { 'modified_date': this.$myConstants.currentDate() })
        await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: rowSerialChangeLog1})});

        

        // tạo thêm product_serial_number_info_status_changed
        var paramsInfoLogStatus = {
          serial_number_id: isNaN(this.changed_serial_number_new_id)? 0 :this.changed_serial_number_new_id, 
          new_warranty_status: 2,
          new_verify_status: 0,
          modifier_id: this.$store.getters.fullname.id,
          customer_profile_id: customerID,
          organization_id: organizationUser,
          modified_date: this.$myConstants.currentDate(),
          source: 'web'
        }
        paramsInfoLogStatus = Object.assign(paramsInfoLogStatus, { 'request_activation_id': this.request_activation_id })
        await DataServices.insertData('product_serial_number_info_status_changed', {"variables": JSON.stringify({objects: paramsInfoLogStatus})});
        
        await DataServices.updateData('request_activation', {"variables": JSON.stringify({data_update: {process_status: 1, status: 0}, where_key: {id: {'_eq': this.request_activation_id}}})});
      }
     
      this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
      this.showConfirmDialog = false;
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    },
    
    async checkSeiralNumber(serialNumber) {
      this.errorReject = -1;
      if (serialNumber == this.serial_number) {
        this.errorReject = 1;
        this.errorReasonNote = 'Vui lòng chọn sản phẩm thay thế';
      }
      else {
        var variables = {
          where_key: {
            product_serial_number: {
              serial_number: {'_eq': serialNumber },
              production_status: {'_eq': 1},
              status: {'_eq': 1}
            },
            serial_number_id: {'_neq': this.serial_number_id},
            status: {'_eq': 1}
          }
        }
        var data = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variables), "fields": "serial_number_id product_id product_serial_number { serial_number  } products { model_code } warranty_status verify_status"});
        var list = data[Object.keys(data)];
        if (list != null && list.length > 0) {
          var dataSerial = list[0];
          // console.log('dataSerial', dataSerial);
          this.changed_serial_number_new_id = dataSerial.serial_number_id;
          var serialNumberCode = dataSerial.products.model_code;
          if (serialNumberCode != this.model_code) {
            this.errorReject = 1;
            this.errorReasonNote = 'Vui lòng đổi sản phẩm mới cùng mã sản phẩm cũ';
          } else {
            if (dataSerial.warranty_status == 1 || dataSerial.warranty_status == 3 || dataSerial.warranty_status == 4) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đã kích hoạt bảo hành. Vui lòng nhập lại serial number';
            } else if (dataSerial.warranty_status == 2) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đang chờ kích hoạt bảo hành.Vui lòng nhập lại serial number';
            } else {
              this.errorReject = 0;
              this.errorReasonNote = '';
            }
          }
        } else {
          var variables1 = {
            where_key: {
              serial_number: {'_eq': serialNumber },
              production_status: {'_eq': 1},
              status: {'_eq': 1}
            }
          }
          var data1 = await DataServices.getList('product_serial_number', {"variables": JSON.stringify(variables1), "fields": "id serial_number warranty_status product { model_code }"});
          var list1 = data1[Object.keys(data1)];
          if (list1 != null && list1.length > 0) {
            var dataSerial1 = list1[0];
            if (dataSerial1.warranty_status == 1 || dataSerial1.warranty_status == 3) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đã kích hoạt bảo hành. Vui lòng nhập lại serial number';
            } else if (dataSerial1.warranty_status == 2) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đang chờ kích hoạt bảo hành.Vui lòng nhập lại serial number';
            } else {
              var serialNumberModelCode = dataSerial1.product.model_code;
              if (serialNumberModelCode == this.model_code) {
                this.errorReject = 0;
                this.changed_serial_number_new_id = dataSerial1.id;
              } else {
                this.errorReject = 1;
                this.errorReasonNote = 'Vui lòng nhập mã serial cùng model với sản phẩm cũ'; 
              }
            }
          } else  {
            this.errorReject++;
            this.errorReasonNote = 'Vui lòng nhập mã serial cùng model với sản phẩm cũ';
          }
        }
        if (this.errorReject == 0) {
          this.showConfirmDialog = true;
        }
      }
    },
    changeReason() {
      this.submitReject = false;
      if(!this.reasonItem.is_change_product) this.changed_serial_number_id = '';
      if(!this.reasonItem.is_add_info) this.reason_note = '';
    },
    async settingReasonReject() {
      var variables = {
        where_key: {
          status: {'_in': [1] },
          reason_type: {'_eq': 'warranty_discontinuation'}
        },
        orderBy: {
          ordering: 'asc'
        }
      }
      var data = await DataServices.getList('setting_reason_reject', {"variables": JSON.stringify(variables), "fields": "id reason_name  is_add_note is_change_product"});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null) {
        for (let index = 0; index < list.length; index++) {
          const ele = list[index];
          this.reasonTypes.push({name: ele.reason_name , value: ele.id, is_add_info: ele.is_add_note, is_change_product: ele.is_change_product});
        }
      }
    },
    async getData() {
      var modelName = 'request_activation_product_serial';
      var variables = {
        where_key: {
          id: {'_eq': this.product_serial_id }
        }
      }
      var data = await DataServices.getList(modelName, {"variables": JSON.stringify(variables), 'fields': 'request_activation_id serial_number_id warranty_status verify_status request_activation { created_date modified_date  customer_type customer_name date_of_sale customer_profile { full_name phone_number  user { user_type } }  invoice_images acceptance_images }'});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null && Object.keys(list).length > 0) {
        var records = list[0];
        this.request_activation_id = records.request_activation_id;
        
        if (records.request_activation != undefined && records.request_activation != null  ) {
          var userType = (records.request_activation.customer_profile != undefined && records.request_activation.customer_profile != null) ? records.request_activation.customer_profile.customer_type : 0;
          if (records.request_activation.customer_profile != undefined && records.request_activation.customer_profile != null) {
            this.full_name = records.request_activation.customer_profile.full_name;
            this.phone_number = records.request_activation.customer_profile.phone_number;
            this.phone_number = this.phone_number.replace('+84', '0');
          }
          
          if (records.request_activation.customer_name != undefined && records.request_activation.customer_name != null) {
            this.full_name = records.request_activation.customer_name;
          }

          if (records.request_activation.customer_type != undefined && records.request_activation.customer_type != null) {
            userType = records.request_activation.customer_type;
          }

          if (userType == 1) this.group_customer = 'Cá nhân';
          else if (userType == 2) this.group_customer = 'Doanh nghiệp';

          if(records.request_activation.invoice_images != null && records.request_activation.invoice_images != '') {
            this.invoiceImagesTmp = records.request_activation.invoice_images;
            var images = this.$myConstants.isJSON(records.request_activation.invoice_images);
            if (images != false) {
              var json = JSON.parse(records.request_activation.invoice_images);
              this.invoiceImages = json;
            } else this.invoiceImages = images;
          }
          if (this.invoiceImages != null) {
            for (let index = 0; index < this.invoiceImages.length; index++) {
              var item = this.invoiceImages[index];
              var path = item.url != undefined ? item.url : (item.cdn != null ? item.cdn + '' + item.path : item.path);
              this.lstImages.push({src: path});
            }
          }
          
          //this.waittingActive = (records.warranty_status == 2) ? true : false;
          this.verify_status = records.verify_status;
          this.warranty_status_number = records.warranty_status;
          if (this.warranty_status_number == 2) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(153, 0, 204);">Chờ kích hoạt</abbr>';
          else if (this.warranty_status_number == 0 || this.warranty_status_number == 5) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgba(255, 102, 0, 1);">Chưa kích hoạt</abbr>';
          else if (this.warranty_status_number == 4) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(51, 0, 204);">Hết bảo hành</abbr>';
          else if (this.warranty_status_number == 6) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(0, 0, 0);">Sản phẩm huỷ</abbr>';
          else if (this.warranty_status_number == 3 || this.warranty_status_number == 1) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(0, 204, 0);">Đã kích hoạt</abbr>';


        }
        this.serial_number_id = records.serial_number_id;
        
        
        await this.getDataProduct( records.serial_number_id, records);
        await this.getDataLog( records.request_activation_id, records.serial_number_id);
        await this.getDynamicForm(records.request_activation_id, records.serial_number_id);
        this.loadPopupExtend(records.warranty_status,records.serial_number_id);
      }
    },
    async loadPopupExtend(warranty_status_number,serial_number_id) {
      var vm = this;
      //defaul ngày hết hạn bảo hành dự kiến
      this.popupExtend.expected_warranty_expiration_date =  '';
      this.popupExtend.activation_date = moment().tz(this.$myConstants.timeZone()).format();//Lấy ngày hiện tại là ngày kích hoạt bảo hành
      console.log("this.popupExtend.activation_date",this.popupExtend.activation_date)
      /*this.popupExtend.activation_date = this.listData.activation_date;
      this.popupExtend.warranty_time = this.warranty_time;
      this.popupExtend.warranty_unit = this.listData.warranty_unit;*/
      //Check điều kiện hiển thị nút gia hạn bào hành
      /*
      Biểu tượng chỉnh sửa thông tin sản phẩm (gia hạn thời gian bảo hành) chỉ hiển thị để nhấn khi sản phẩm được kích hoạt là được thực hiện từ quy trình Đổi sản phẩm và sản phẩm cũ đã hết thời gian đổi quy định
      * */
      //Lấy cấu hình số ngày gia hạn bảo hành tối đá
      var whereObjectSetting = {
        key: {'_eq': this.$dataCommon.SETTING.MAXIMUM_WARRANTY_EXTENSION_TIME}
      }
      var resObjSetting = await  DataServices.getObjectData('settings', whereObjectSetting, {id: 'desc'});
      var maximum_warranty_extension_time_setting = (!vm.$myConstants.isEmpty(resObjSetting.value)) ? parseFloat(resObjSetting.value):0;

      //if (warranty_status_number == 3 || warranty_status_number == 1){
      if (warranty_status_number == 2){
        //check sản phẩm có phải đổi trả
        var whereRequestReturnProduct = {
          change_serial_number_id: {'_eq': serial_number_id},
          return_type: {'_eq': 0},
        }
        var checkRequestReturnProduct =await  DataServices.getObjectData('request_return_product', whereRequestReturnProduct, {id: 'desc'});
        if (!this.$myConstants.isEmpty(checkRequestReturnProduct)){
          //check sản phẩm cũ đã hết thời hạn đổi
          if (!this.$myConstants.isEmpty(checkRequestReturnProduct.serial_number)){
            var serial_number_old = checkRequestReturnProduct.serial_number.serial_number;
            var serial_old_data = await this.$coreService.getSerialWarrantyActivationBySerial(serial_number_old);
            console.log("serial_old_dataserial_old_dataserial_old_data:",serial_old_data)
            if (serial_old_data){
              var activation_date_data_old = (!this.$myConstants.isEmpty(serial_old_data.data_info_serial)) ? serial_old_data.data_info_serial.activation_date_data:null;
              var change_time_data_old = (!this.$myConstants.isEmpty(serial_old_data.data_info_serial)) ? serial_old_data.data_info_serial.change_time_data:null;
              var warranty_time_data_old = (!this.$myConstants.isEmpty(serial_old_data.data_info_serial)) ? serial_old_data.data_info_serial.warranty_time_data:null;
              var warranty_unit_data_old = (!this.$myConstants.isEmpty(serial_old_data.data_info_serial)) ? serial_old_data.data_info_serial.warranty_unit_data:null;
              if (activation_date_data_old){
                var now_date = new Date();
                var endReturn = now_date.getTime();
                var one_day = (1000 * 60 * 60 * 24);
                var startReturn =  this.$myConstants.convertToDate(activation_date_data_old, 0,  'days');
                startReturn = new Date(startReturn.format('YYYY'), startReturn.format('MM') - 1, startReturn.format('DD')).getTime();
                var daysStartReturn = Math.floor(startReturn) / (one_day);
                var daysEndReturn = Math.floor(endReturn) / (one_day);
                if ((daysEndReturn - daysStartReturn) > change_time_data_old) {
                  //show button gia hạn bào hành
                  this.display_btn_warranty_extension = true;
                  //load số ngày gia hạn tối đa

                  //tính toán ra số ngày
                  var unit_map_wt = this.$dataCommon.COVERT_UNIT_MOMMENT[warranty_unit_data_old];
                  //console.log("unit_map_wtunit_map_wtunit_map_wt:",unit_map_wt)
                  var expiredDate = this.$myConstants.convertToDate(activation_date_data_old, warranty_time_data_old, unit_map_wt);
                  var date1 = new Date((now_date.getMonth() + 1) + "/" + now_date.getDate() + "/" + now_date.getFullYear());
                  var date2 = new Date(expiredDate.format('MM') + "/" + expiredDate.format('DD') + "/" + expiredDate.format('YYYY'));
                  var diffTimewt = Math.abs(date2 - date1);
                  var diffDayswt = Math.ceil(diffTimewt / (1000 * 60 * 60 * 24));
                  this.remaining_warranty_period_old = diffDayswt;
                  this.change_number_ext_days();//Tình ngày hết hạn bảo hành dự kiến
                  //this.popupExtend.warranty_time :chuyển tính ngày
                  var calcDayWarranty = 0;
                  if (this.warranty_time_tmp_data){
                    //lấy thời gian bảo hành lúc đầu để tính đúng số ngày tối đa
                    calcDayWarranty = this.convertDayWarranty(this.popupExtend.activation_date,this.warranty_unit_tmp_data,this.warranty_time_tmp_data);
                  }else {
                    //ko tồn tại thời gian bảo hành tmp
                    calcDayWarranty = this.convertDayWarranty(this.popupExtend.activation_date,this.warranty_unit,this.warranty_time_data);
                  }

                  /*console.log("calcDayWarrantycalcDayWarrantycalcDayWarranty:",calcDayWarranty)
                  console.log("diffDayswtdiffDayswtdiffDayswt:",diffDayswt)*/
                  //console.log("this.warranty_timethis.warranty_time:",this.warranty_time)
                  if ((calcDayWarranty - diffDayswt) > maximum_warranty_extension_time_setting ){
                    vm.popupExtend.maximum_warranty_extension_time = maximum_warranty_extension_time_setting;
                  }else {
                    vm.popupExtend.maximum_warranty_extension_time = ((calcDayWarranty - diffDayswt) <0) ? 0:(calcDayWarranty - diffDayswt);
                  }
                }
              }
            }
          }

        }
      }

    },
    convertDayWarranty(activation_date,warranty_unit,warranty_time){
      var calcDayWarranty = 0;
      if (warranty_unit == 'month'){
        var map_warranty_unit = this.$dataCommon.COVERT_UNIT_MOMMENT[warranty_unit];
        calcDayWarranty = this.$myConstants.calcDayByMonth(activation_date, warranty_time,map_warranty_unit);
      }else if (warranty_unit == 'day'){
        calcDayWarranty = warranty_time;
      }
      return calcDayWarranty;
    },
    async getDataProduct(serialID, records) {
      var name = 'product_serial_number_info';
      var variables = {
        where_key: {
          serial_number_id: {'_eq': serialID },
          status: {'_eq': 1}
        }
      }
      var data = await DataServices.getList(name, {"variables": JSON.stringify(variables), "fields": "serial_number_id product_id request_activation_id activation_date product_serial_number { modified_date created_date production_order_code_one { manufacturing_date } serial_number warranty_status production_status production_order_code product_id status product { warranty_time warranty_unit change_time change_unit returnable_time returnable_unit is_manually_verification}} customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit warranty_time_tmp warranty_unit_tmp is_returnable change_time change_unit returnable_time  returnable_unit last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form categories { name } request_activation { customer_profile_id organization_id }"});
      var list = data[Object.keys(data)];
      if (list != null && list.length) {
        this.listData = list[0];
        console.log("this.listDatathis.listData:",this.listData)
        this.serial_number = this.listData.product_serial_number.serial_number;
        this.activation_date = this.listData.activation_date;
        this.returnable_time = (this.listData.returnable_time != undefined && this.listData.returnable_time != null) ? this.listData.returnable_time : 0;
        this.change_time = (this.listData.change_time != undefined && this.listData.change_time != null) ? this.listData.change_time : 0;
        
        this.warranty_time = (this.listData.warranty_time != undefined && this.listData.warranty_time != null) ? this.listData.warranty_time : '';
        this.warranty_time_data = this.warranty_time;
        this.warranty_unit = (this.listData.warranty_unit != undefined && this.listData.warranty_unit != null) ? this.listData.warranty_unit : '';
        this.warranty_time_tmp_data = (this.listData.warranty_time_tmp != undefined && this.listData.warranty_time_tmp != null) ? this.listData.warranty_time_tmp : null;
        this.warranty_unit_tmp_data = (this.listData.warranty_unit_tmp != undefined && this.listData.warranty_unit_tmp != null) ? this.listData.warranty_unit_tmp : null;
        /*this.popupExtend.activation_date = this.listData.activation_date;
        this.popupExtend.warranty_time = this.warranty_time;
        this.popupExtend.warranty_unit = this.listData.warranty_unit;*/
        var map_warranty_unit = this.$dataCommon.COVERT_UNIT_MOMMENT[this.listData.warranty_unit];
        this.warranty_activation_time = this.warranty_time;
        //if(records.activation_date != null && records.warranty_time != null && (this.listData.warranty_status == 3 || records.warranty_status == 4)) {
        if(this.listData.activation_date != null && this.warranty_time != null && (this.listData.warranty_status == 3 || records.warranty_status == 4)) {

          this.expired_activation_date = moment(this.listData.activation_date).add(this.warranty_time, map_warranty_unit);
          // this.expired_activation_date =  moment.utc(this.expired_activation_date).local().format('DD/MM/YYYY');
          this.expired_activation_date = moment.tz(this.expired_activation_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');

        }
        // this.activation_date =  moment.utc(this.activation_date).local().format('DD/MM/YYYY');
        if (records.warranty_status == 3 || records.warranty_status == 4) {
          this.activation_date =  moment.tz(this.activation_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
        } else this.activation_date = '';
    
        if(records.request_activation.date_of_sale != null  && records.warranty_status !== 0 && (records.warranty_status == 2 || records.warranty_status == 3 || records.warranty_status == 4)) {
          // this.date_of_sale =  moment.utc(this.listData.date_of_sale).local().format('DD/MM/YYYY');
          this.date_of_sale = moment.tz(records.request_activation.date_of_sale, this.$myConstants.timeZone()).format('DD/MM/YYYY');
        }
        var date_production = (this.listData.product_serial_number != undefined && this.listData.product_serial_number != null && this.listData.product_serial_number.production_order_code_one != undefined && this.listData.product_serial_number.production_order_code_one != null) ? moment(this.listData.product_serial_number.production_order_code_one.manufacturing_date).format('DD/MM/YYYY') : '';
        if (!this.$myConstants.isEmpty(date_production)){
          this.created_date = date_production;
        }else {
          if (this.listData.product_serial_number.modified_date != null) {
            // this.created_date =  moment.utc(this.listData.product_serial_number.modified_date).local().format('DD/MM/YYYY');
            this.created_date = moment.tz(records.request_activation.modified_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
          } else if (records.request_activation.created_date != null) {
            // this.created_date =  moment.utc(this.listData.product_serial_number.created_date).local().format('DD/MM/YYYY');
            this.created_date = moment.tz(records.request_activation.created_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
          }
        }
        this.model_code = this.listData.model_code;
        // this.reason_warranty = this.listData.description;
        var dataSerial = await DataServices.getList('request_activation_product_serial', {"variables": JSON.stringify({ where_key: { request_activation_id: {'_eq': this.request_activation_id }, status: {'_eq': 1}, serial_number_id: {'_eq': serialID } } }), "fields": "verify_status warranty_status"});
        var listSerial = dataSerial[Object.keys(dataSerial)];
        if (listSerial != undefined && listSerial != null && Object.keys(listSerial).length > 0) {
          this.visibleWarranty = (listSerial[0].warranty_status == 3 || listSerial[0].warranty_status == 1 || listSerial[0].warranty_status == 4)  ? true : false;
        }

        //var arrs = this.$myConstants.returnDateCustomText(this.warranty_time, this.returnable_time, this.change_time, records.warranty_status, records.activation_date);
        var dataDateArr = {
          warranty_time:this.warranty_time,
          returnable_time:this.returnable_time,
          change_time:this.change_time,
          warranty_status:records.warranty_status,
          activation_date:this.listData.activation_date,
          arrWarrantyStatus:null,
          warranty_unit:this.listData.warranty_unit
        }
        var arrs = this.$myConstants.returnDateCustomText(dataDateArr);
        this.warranty_time = arrs.warranty_time_text;
        this.returnable_time = arrs.returnable_time_text;
        this.change_time = arrs.change_time_text;

      }
    },
    async getDataLog(request_activation_id, serial_number_id) {
      var nameLog = 'product_serial_number_info_log_changed';
      var variables = {
        where_key: {
          request_activation_id: {'_eq': request_activation_id},
          serial_number_id: {'_eq': serial_number_id}
        },
        orderBy: {
          id: 'desc'
        }
      }
      var data = await DataServices.getList(nameLog, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModelLog = DataServices.getModel(nameLog);
      this.dataModelLog.processData(list);
      this.listDataLog = list;
      if (this.listDataLog.length > 0) {
        var firstData = this.listDataLog[0];
        var newValue = firstData.new_value;
        if (newValue && newValue != null) {
          var jsonValue = JSON.parse(newValue);
          if (jsonValue && jsonValue != null && jsonValue.warranty_message != undefined && jsonValue.warranty_message != null) {
            this.reason_warranty = jsonValue.warranty_message;
            this.reason_warranty_old = this.reason_warranty;
          }
        }
        
        for (let index = 0; index < this.listDataLog.length; index++) {
          var item = this.listDataLog[index];
          var newValueTmp = item.new_value;
          if (newValueTmp && newValueTmp != null) {
            var jsonValueTmp = JSON.parse(newValueTmp);
            if (jsonValueTmp && jsonValueTmp != null && jsonValueTmp.acceptance_images) {
              var acceptances = jsonValueTmp.acceptance_images;
              if (this.$myConstants.isJSON(acceptances)) {
                acceptances = JSON.parse(acceptances);
              }
              for (let index = 0; index <acceptances.length; index++) {
                var image = acceptances[index];
                if (image && typeof image == 'object') {
                  var url = (image.path != undefined && image.path != null) ? image.path : 
                  ((image.url != undefined && image.url != null) ? image.url : '');
                  if (url != '') this.lstAcceptance.push({src: url});
                } else this.lstAcceptance.push({src: image});
              }
              if (this.lstAcceptance.length > 0) break;
            }
          }
        }
      }
      this.componentKeyLog++;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.rows = function (rowData) {
        var buttons = {}
        buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `/admin/warranty-activation/view`}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'edit':
          this.$router.push(action.path + '/' + data.data[action.key])
          break;
      }
    },
    backList() {
      this.$router.go(-1);
    },
    editProducts() {
      //this.warranty_activation_time = 0;
      this.warranty_activation_note = '';
      this.submitChangeProduct = false;
      this.displayDialogChangeProduct = true;
    },
    async change_number_ext_days(){
      var expired_activation_date = null;
      var days_warranty_extension = this.calc_days_warranty_extension();
      //console.log("days_warranty_extensiondays_warranty_extensio:",days_warranty_extension)
      expired_activation_date = moment(this.popupExtend.activation_date).add(days_warranty_extension, 'days');
      this.popupExtend.expected_warranty_expiration_date = moment.tz(expired_activation_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');

      /*if (!this.$myConstants.isEmpty(this.popupExtend.number_extension_days)){
        if (this.popupExtend.number_extension_days >= 0){
          var days_warranty_extension = this.calc_days_warranty_extension();
          //console.log("days_warranty_extensiondays_warranty_extensio:",days_warranty_extension)
          expired_activation_date = moment(this.popupExtend.activation_date).add(days_warranty_extension, 'days');
          this.popupExtend.expected_warranty_expiration_date = moment.tz(expired_activation_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
        }else {
          //console.log("5555555555555555")
          expired_activation_date = moment(this.popupExtend.activation_date).add(0, 'days');
          this.popupExtend.expected_warranty_expiration_date = moment.tz(expired_activation_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
        }
      }else {
        this.popupExtend.expected_warranty_expiration_date = '';
      }*/

    },
    calc_days_warranty_extension(){
      var calcDayWarranty = (this.remaining_warranty_period_old<0) ? 0:this.remaining_warranty_period_old;
      /*if (this.popupExtend.warranty_unit == 'month'){
        var map_warranty_unit = this.$dataCommon.COVERT_UNIT_MOMMENT[this.popupExtend.warranty_unit];
        calcDayWarranty = this.$myConstants.calcDayByMonth(this.popupExtend.activation_date, this.popupExtend.warranty_time,map_warranty_unit);
        calcDayWarranty = this.$myConstants.calcDayByMonth(this.popupExtend.activation_date, this.popupExtend.warranty_time,map_warranty_unit);
      }else if (this.popupExtend.warranty_unit == 'day'){
        calcDayWarranty = this.popupExtend.warranty_time;
      }*/
      var number_extension_days = (!this.$myConstants.isEmpty(this.popupExtend.number_extension_days)) ? this.popupExtend.number_extension_days:0
      var currentDaysPlus = calcDayWarranty + number_extension_days;
      return currentDaysPlus;
    },
    async validationData() {
      //var vm =this;
      this.validationErrors = {};
      if (this.$myConstants.isEmpty(this.popupExtend.number_extension_days)){
        this.validationErrors['number_extension_days'] = 'Nhập số ngày gia hạn';
      }else {
        if (parseFloat(this.popupExtend.number_extension_days) > parseFloat(this.popupExtend.maximum_warranty_extension_time)){
          this.validationErrors['number_extension_days'] = 'Nhập vượt số ngày tối đa';
        }
      }
      if (this.$myConstants.isEmpty(this.popupExtend.warranty_activation_note)){
        this.validationErrors['warranty_activation_note'] = 'Nhập nguyên nhân gia hạn thời gian bảo hành';
      }
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    async changeProductData() {
      await this.validationData();
      if (Object.entries(this.validationErrors).length === 0) {
        this.submitChangeProduct = true;
        this.warranty_activation_note = this.popupExtend.warranty_activation_note.trim();
        var rowSerialOld = this.listData;
        var rowSerialNew = rowSerialOld;
        this.warranty_activation_time = this.calc_days_warranty_extension();
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var whereKey = {
          request_activation_id: {'_eq': this.request_activation_id},
          serial_number_id: {'_eq': this.serial_number_id}
        }
        var paramsUpdate = {
          modified_date: this.$myConstants.currentDate(),
          warranty_time: this.warranty_activation_time,
          warranty_unit: 'day'
        }
        /*console.log("this.warranty_time_tmp_data:",this.warranty_time_tmp_data);
        console.log("this.warranty_time_data:",this.warranty_time_data);
        console.log("this.warranty_unit:",this.warranty_unit);*/
        if (this.$myConstants.isEmpty(this.warranty_time_tmp_data)){
          //Lưu lại thời gian ban đầu trước khi gia hạn
          paramsUpdate.warranty_time_tmp = this.warranty_time_data;
          paramsUpdate.warranty_unit_tmp = this.warranty_unit;
        }
        await DataServices.updateData('product_serial_number_info', {
          "variables": JSON.stringify({
            data_update: paramsUpdate,
            where_key: whereKey
          })
        });

        rowSerialNew['message'] = "Số ngày gia hạn thêm: " + this.popupExtend.number_extension_days+', ';
        if (this.reason_warranty_old != '' && this.reason_warranty_old.length > 0) {
          rowSerialNew['message'] += "Nguyên nhân gia hạn thời gian BH: " + this.reason_warranty_old + ' thành ' + this.warranty_activation_note;
        } else rowSerialNew['message'] += "Nguyên nhân gia hạn thời gian BH: " + this.warranty_activation_note;
        rowSerialNew['warranty_message'] = this.warranty_activation_note;
        rowSerialNew['warranty_time'] = this.warranty_activation_time;
        var rowSerialChangeLog = {};
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, {'request_activation_id': this.request_activation_id})
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, {'serial_number_id': this.serial_number_id})
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, {'modifier_id': this.$store.getters.fullname.id})
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, {'old_value': JSON.stringify(rowSerialOld)})
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, {'new_value': JSON.stringify(rowSerialNew)})
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, {'created_date': this.$myConstants.currentDate()})
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, {'modified_date': this.$myConstants.currentDate()})
        await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: rowSerialChangeLog})});

        //this.$store.commit('setLoading', false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);

          // await this.addHistoryModelProductImport();
      }else {
        return false;
      }
    },
    async changeProductData_1() {
      this.submitChangeProduct = true;
      this.warranty_activation_note = this.warranty_activation_note.trim();
      var rowSerialOld = this.listData;
      var rowSerialNew = rowSerialOld
      if (this.warranty_activation_note.length > 0 && this.warranty_activation_time > 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var whereKey = { request_activation_id: {'_eq': this.request_activation_id }, serial_number_id: {'_eq': this.serial_number_id } }
        var paramsUpdate = { modified_date: this.$myConstants.currentDate(), warranty_time: this.warranty_activation_time}
        await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: paramsUpdate, where_key: whereKey})});
        
        rowSerialNew['message'] = "Thời gian bảo hành: " + rowSerialOld.warranty_time + ' tháng thành ' + this.warranty_activation_time+ ' tháng ';
        if (this.reason_warranty_old != '' && this.reason_warranty_old.length > 0) {
          rowSerialNew['message'] += "Lý do đổi thời hạn BH: " + this.reason_warranty_old + ' thành ' + this.warranty_activation_note;
        } else  rowSerialNew['message'] += "Lý do đổi thời hạn BH: " + this.warranty_activation_note;
        rowSerialNew['warranty_message'] = this.warranty_activation_note;
        rowSerialNew['warranty_time'] = this.warranty_activation_time;
        var rowSerialChangeLog = {};
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'request_activation_id': this.request_activation_id })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'serial_number_id': this.serial_number_id })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'modifier_id': this.$store.getters.fullname.id })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'old_value': JSON.stringify(rowSerialOld) })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'new_value': JSON.stringify(rowSerialNew) })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'created_date': this.$myConstants.currentDate() })
        rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'modified_date': this.$myConstants.currentDate() })
        await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: rowSerialChangeLog})});

        this.$store.commit('setLoading', false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);

        // await this.addHistoryModelProductImport();
        
      }
    },
    async addHistoryModelProductImport() {
      var productID = this.listData.product_id;
      var userID = this.$store.getters.fullname.id;
      var organizationID = (this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null && this.$store.getters.fullname.organization_account.organization_id != undefined) ? this.$store.getters.fullname.organization_account.organization_id : 0;
      var dataProduct = await DataServices.getList('product', {"variables": JSON.stringify({where_key: { id: {'_eq': productID}}}), "fields": "id description created_date category_id is_manually_verification is_returnable last_modifier model_code modified_date name production_status qr_code_size change_time change_unit returnable_time returnable_unit slug status warranty_unit warranty_time thumbnail_id thumbnails { external_path cdn_path local_path  }"});
      var listProduct = dataProduct[Object.keys(dataProduct)];
      
      if (listProduct !== undefined && listProduct !== null && Object.keys(listProduct).length) {
        var paramsUpdate = { modified_date: this.$myConstants.currentDate(), warranty_time: this.warranty_activation_time}
        await DataServices.updateData('product', {"variables": JSON.stringify({data_update: paramsUpdate, where_key: {id: {'_eq': productID}}})});

        var oldProduct = listProduct[0];
        var newProduct = oldProduct;
        newProduct['warranty_time'] = this.warranty_activation_time;
        var params = {product_id: productID, modifier_id: userID, organization_id: organizationID, modified_date: this.$myConstants.currentDate(), created_date: this.$myConstants.currentDate(), status: 0, old_value: oldProduct, new_value: newProduct};
        await DataServices.insertData('product_changed_log', {"variables": JSON.stringify({objects: params})});

        this.$store.commit('setLoading', false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
    async getDynamicForm(requestID, serialNumberID) {
      this.dynamicForms = [];
      var nameDynamic = 'product_serial_number_dynamic_form';
      var variables = {
        where_key: {
          request_activation_id: {'_eq': requestID},
          serial_number_id: {'_eq': serialNumberID},
          status: {'_eq': 1}
        }
      }
      var data = await DataServices.getList(nameDynamic, {"variables": JSON.stringify(variables), "fields": "serial_number_id data_dynamic_form"});
      var list = data[Object.keys(data)];
      if (list && list != null && Array.isArray(list) && list.length) {
        var dataDynamic = list[0];
        if (dataDynamic.data_dynamic_form !== undefined && dataDynamic.data_dynamic_form != null && Object.keys(dataDynamic.data_dynamic_form).length) {
          var forms = JSON.parse(dataDynamic.data_dynamic_form);
          if (forms && forms != null && Array.isArray(forms) && forms.length) {
            for (let index = 0; index < forms.length; index++) {
              const item = forms[index];
              if (item && item.fields && item.fields != null && Object.keys(item.fields).length) {
                var dynamicName = item.fields.name;
                var dynamicValue = item.fields.value;
                if (item.fields.backend_type == 'date' && item.fields.validation != undefined && item.fields.validation != null) {
                  var validation =  JSON.parse(item.fields.validation);
                  if (dynamicValue != null && validation.date && validation.date.format != undefined && validation.date.format != '') {
                    dynamicValue = moment(dynamicValue).format(validation.date.format);
                  }
                }
                this.dynamicForms.push({name: dynamicName, value: dynamicValue});
              }
            }
          }
        }
      }
    },
    setIndex(index) {
      this.indexInvoice = index
    },
    setIndexAcceptance(index) {
      this.indexAcceptance = index
    }
  }
}
</script>
<style lang="scss">
.box-top-list{ margin-bottom: 0px;
  &.last-changed{margin-bottom: 15px;}
  span{font-size: 20; text-align: left; }
  .right-button{float: right;}
  &.box-info-product{margin-bottom: 10px; margin-top: 20px;
    .right-button{ position: relative; top: -12px;
      .p-button-edit{border-radius: 50%; height: 2.357rem; width: 2.357rem; padding: 0.5rem 0; margin: 0 !important;}
    }
  }
  .format-title{font-weight: bold; font-size: 25px;}
}
.box-info{ padding: 0 20px;
  &.list-product{margin-bottom: 30px;}
  .box-info-title{ font-size: 16px; font-weight: 700; margin-bottom: 10px; margin-top: 20px;}
  .box-invoice-img{
    img{margin-right: 20px;
      &:last-child{margin: 0;}
    }
  }
  .form-info{
    .p-field{ padding: 10px;
      &:nth-child(n) {background: #E4E4E4;}
      &:nth-child(2n) {background: #fff;}
      label{ width: 200px; margin: 0;}
    }
  }
  .btn-function {margin-top: 15px;
    button{width: 170px; margin-right: 15px;}
  }
}
.box-reason{ padding: 10px 20px;
}
.dialog-reject{overflow: visible;
  .dialog-content{padding: 10px 30px;
    p{font-size: 16px;}
  }
  .p-dialog-footer{text-align: center; border: 0 none; padding-bottom: 20px;
    button{width: 150px; margin-right: 15px; text-transform: uppercase;
      &:last-child{margin-right: 0;}
    }
  }
}
.custom-error{display: block; color: #f00; margin-top: 10px;}
.box-list-img{
  .item{position: relative; width: 100px; 
    .remove-icon{position: absolute; right: -3px; color: #fff; background: #f00; width: 15px; height: 15px; overflow: hidden; border-radius: 50%;
      span{color: #fff; font-size: 8px; position: relative;top: -7px; left: 4px; font-weight: bold;}
    }
    .img {padding-top: 6px;
      img{max-width: 100%; height: auto;}
    }
  }
}
.edit-time-product{ margin-bottom: 20px;
  .p-inputtext{margin-right: 100px;}
  .p-inputgroup-addon{color:#333; background: transparent; border: 0 none; text-align: right; flex: auto; justify-content: flex-end;}
}
.images-wrapper { display: flex;
  .image {height: 150px; width: 100px; display: block; margin-right: 20px; cursor: pointer; background-size: contain; background-repeat: no-repeat;
    &:last-child{margin: 0;}
  }
}
.timeline{ font-weight: bold; font-style: italic; padding-left: 5px;}
.box_extend{
  .group_input_day{
    .warranty_activation_time{
      width: calc(100% - 65px);height: 30px
    }
    .refix-wat{
      margin-left: 8px;
    }
  }
  .style_time_max{
    font-style: italic; font-size: 13px; color: #666666;
    span{
      font-weight: 700;
    }
  }
  .box_expiration_date{
    background-color: #fafafa;height: 30px;
    img{
      float: right;margin-top: 3px;height: 20px;width: 18px;
    }
  }
}
</style>